import { useEffect, useState } from "react";
import CeoApi from "../apis/ceo.api";
import UserApi from "../apis/user.api";
import { setHomeData } from "../pages/home/homeSlice";
import { dispatch, useSelector } from "../store";
import useAuth from "./useAuth";
import { updateCeoStatus } from "../actions/CeoStatus";
import { updateCeoAccountStatus } from "../actions/CeoAccountStatus";
import { store } from "../store";

export function useFetchHome() {
  const { ceoInfo } = useAuth();
  const { homeData } = useSelector((state) => state.home);
  const [reviewChartData, setReviewChartData] = useState([]);
  const [starChartData, setStarChartData] = useState([]);
  const [isHomeEmptyData, setIsHomeEmptyData] = useState(true);
  const [shopInfo, setShopInfo] = useState();
  const { ceoStatus } = useSelector((state) => state.CeoStatus);

  function checkEmptyChart(data) {
    return data.every((obj) => obj.data.every((value) => value === 0));
  }

  const genReviewSeries = (data) => {
    const fields = ["specialReviewCnt", "generalReviewCnt"];
    return fields.map((name) => {
      return {
        name,
        data: data?.map((o) => {
          return o[name];
        }),
      };
    });
  };

  const genStarSeries = (data) => {
    const fields = ["1", "2", "3", "4", "5"];
    return fields.map((name) => {
      return {
        name,
        data: data?.map((o) => {
          return o.stars?.[name];
        }),
      };
    });
  };

  const getHome = async () => {
    if (ceoInfo?.shop_idx) {
      const response = await CeoApi.getHome({
        shop_idx: ceoInfo?.shop_idx,
      });
      const reviewChartData = genReviewSeries(
        response.data.data?.reviewInWeek?.reviewByDate
      );

      const starChartData = genStarSeries(
        response.data.data?.averageStar?.starByDates
      );

      setReviewChartData(reviewChartData);
      setStarChartData(starChartData);
      dispatch(setHomeData(response.data.data));
      if (
        !checkEmptyChart(reviewChartData) &&
        !checkEmptyChart(starChartData) &&
        homeData?.failedComment > 0 &&
        homeData?.specialReview > 0 &&
        homeData?.unansweredReview > 0 &&
        homeData?.pendingComment > 0
      ) {
        setIsHomeEmptyData(false);
      }
    }
  };

  const getInfo = async () => {
    if (ceoInfo?.shop_idx) {
      const res = await UserApi.getInfo(ceoInfo?.shop_idx);
      setShopInfo(res.data.data)
    }
  };
  const getCeoStatus = async () => {
    if (ceoInfo?.ceo_idx) {
      const response = await CeoApi.getDeleteStatus(ceoInfo?.ceo_idx);
      if (response.data.data) {
        dispatch(updateCeoStatus(response.data.data));
      }
    }
  }
  const getCeoPremiumStatus = async () => {
    if (ceoInfo?.ceo_idx) {
      const response = await CeoApi.getStatus(ceoInfo?.ceo_idx);
      if (response.data.data) {
        dispatch(updateCeoAccountStatus(response.data.data));
      }
    }
  }

  console.log(store.getState());
  useEffect(() => {
    getHome();
    getInfo();
    getCeoStatus();
    getCeoPremiumStatus();
  }, []);

  return {
    homeData,
    reviewChartData,
    starChartData,
    isHomeEmptyData,
    shopInfo,
    appConnected: homeData?.appConnect || [],
    ceoStatus
  };
}
